// test385
(385 && 0);
